import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import BlogSearch from '../components/BlogSearch.vue'
import BlogAdvancedSearch from '../components/BlogAdvancedSearch.vue'
import mitt from 'mitt';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let target = self.el.dataset.target;

        const emitter = mitt();

        const blogApp = createApp({
            template: '<BlogSearch ' + (target?'target="'+target+'"' : '') + '/>',
            components: {
                BlogSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        if (!target) blogApp.config.globalProperties.emitter = emitter;
        blogApp.mount(self.el);

        if (!target) {
            let advancedSearchDiv = document.getElementById('BlogAdvancedSearch');

            const blogAdvancedApp = createApp({
                template: '<BlogAdvancedSearch />',
                components: {
                    BlogAdvancedSearch
                },
                data() {
                    return {
                    }
                },
                mounted() {
                },
            })
            blogAdvancedApp.config.globalProperties.emitter = emitter;
            blogAdvancedApp.mount(advancedSearchDiv)

        }
    }
}
